import React from 'react';

import config from 'config';
import styled from 'styled-components';

import { useMembership } from '~/techstyle-shared/react-accounts';
import {
  desktop,
  mobile,
  useProductDetailContext,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const FitGuaranteeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 16px 32px;
  text-align: center;
  font-size: 14px;
  ${desktop`
		padding: 64px 0 32px 0;
  	margin: 0 0 32px 0;
		border-top: ${({ theme }) => theme.colors.separator} 2px solid;
	`}
  ${mobile`
		padding: 32px 0 32px 0;
		margin: 0 16px 16px 16px;
		border-top: ${({ theme }) => theme.colors.separator} 2px solid;
		border-bottom: ${({ theme }) => theme.colors.separator} 2px solid;
	`}
`;

const FitGuaranteeHeader = styled.span`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.textEmphasized};

  ${({ theme }) => theme.pdpStyles.fitGuarantee.header}
`;

const FitGuaranteeBody = styled.span`
  letter-spacing: ${-0.17 / 12}em;
  ${desktop`
		max-width: 650px;
	`}

  ${({ theme }) => theme.pdpStyles.fitGuarantee.copy}
`;

const FitGuarantee = () => {
  const { product, isBundle } = useProductDetailContext();
  const { isVip } = useMembership();
  const womensId = config.get('public.productCategories.womens');
  const categoryIdList = isBundle
    ? product.bundleComponentProducts[0]?.productCategoryIdList
    : product.productCategoryIdList;
  const isWomens = categoryIdList?.includes(womensId);

  const isVipWomens = isVip && isWomens;
  const isVipMens = isVip && !isWomens;
  const isLeadWomens = !isVip && isWomens;
  const isLeadMens = !isVip && !isWomens;

  return (
    <FitGuaranteeWrapper data-autotag="pdp-policy-promo-container">
      <FitGuaranteeHeader>
        {isVipWomens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_1"
            defaultMessage="Our 45-Day Perfect Fit Guarantee"
          />
        )}

        {isVipMens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_1_mens_vip"
            defaultMessage="60 Day Wear Test Guarantee"
          />
        )}
        {isLeadWomens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_1_leads"
            defaultMessage="Our 45-Day Fit Guarantee"
          />
        )}
        {isLeadMens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_1_mens"
            defaultMessage="60 Day Wear Test Guarantee"
          />
        )}
      </FitGuaranteeHeader>
      <FitGuaranteeBody>
        {isVipWomens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_2"
            defaultMessage="We've got you covered! If the style you ordered doesn’t fit perfectly, or you don’t love how it looks, you have up to 45 days from shipment to exchange or return."
          />
        )}

        {isVipMens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_2_mens_vip"
            defaultMessage="Sweat in it, sleep in it, roll around in the mud. Bring it. We’ll give you 60 days. If it doesn’t perform, we’ll return your money. No questions asked."
          />
        )}
        {isLeadWomens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_2_leads"
            defaultMessage="Sweat it out for 45 days and if it doesn't perform, return it for a full refund!"
          />
        )}
        {isLeadMens && (
          <FormattedMessage
            id="policy_promo.policy_promo_text_2_mens"
            defaultMessage="Sweat in it, sleep in it, roll around in the mud. Bring it. We’ll give you 60 days. If it doesn’t perform, we’ll return your money. No questions asked."
          />
        )}
      </FitGuaranteeBody>
    </FitGuaranteeWrapper>
  );
};

export default FitGuarantee;
